<template>
    <div>
        <section v-if="!initialLoading">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table
                            id="data-table-list-courses"
                            class="table-hover-animation table-striped table-bordered"
                        >
                            <caption>
                                Lista de cursos eliminados IPSSOMA
                            </caption>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Curso</th>
                                    <th>Precio</th>
                                    <th>Fecha de registro</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(course, index) in this.courses"
                                    v-bind:key="index"
                                >
                                    <td>
                                        <p style="width: 15px">
                                            {{ course.id }}
                                        </p>
                                    </td>
                                    <td>
                                        <p style="width: 220px">
                                            {{ course.nombre }}
                                        </p>
                                    </td>
                                    <td>S/. {{ course.precio }}</td>
                                    <td>{{ course.created_at }}</td>

                                    <td class="align-content-center">
                                        <el-select
                                            v-model="optionSelected"
                                            @change="getOptionSelected(course)"
                                            clearable
                                            size="mini"
                                            remote-show-suffix="false"
                                            clear-icon
                                            id="customize_select"
                                        >
                                            <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <custom-spinner v-else></custom-spinner>

        <custom-modal id="delete-course-modal" color="danger">
            <template #title
                >Borrar curso <u> {{ courseSelected.title }} </u></template
            >
            <template #body>¿Seguro que desea eliminar este curso?</template>
            <template #footer>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="closeModal('delete-course-modal')"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteCourse(courseSelected.id)"
                >
                    Eliminar
                </button>
            </template>
        </custom-modal>
    </div>
</template>
<script>
import ModalComponent from "../ModalComponent.vue";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

export default {
    data() {
        return {
            initialLoading: false,
            courses: [],
            categories: [],
            levels: [],
            options: [
                {
                    value: "1",
                    label: "Módulos y clases",
                },
                {
                    value: "2",
                    label: "Restaurar",
                },
            ],
            optionSelected: "",
            courseSelected: {},
        };
    },
    components: {
        "custom-modal": ModalComponent,
        "custom-spinner": CustomSpinner,
    },

    mounted() {
        this.listCourses();
    },

    methods: {
        closeModal(id) {
            $(`#${id}`).modal("hide");
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-courses").DataTable(language);
            });
        },
        listCourses: function () {
            this.initialLoading = true;
            axios.get(`/course/trash-list`).then((response) => {
                this.courses = response.data;
                this.initialLoading = false;
                this.loadDataTable();
            });
        },
        /**
         * Return data about the option selected in the table
         * @param {object} course - The course object selected
         */
        getOptionSelected(course) {
            let option = this.optionSelected;
            switch (option) {
                case "1":
                    document.location.href = `/productos/module/${course.id}/editModule`;
                    break;
                case "2":
                    this.restore(course);
                    break;
                default:
                    console.log("Error");
                    break;
            }
        },

        async restore(course) {
            try {
                const url = `/course/restore/${course.id}`;
                const { data } = await axios.put(url);
                if (data.status == "ok") {
                    this.$message.success(
                        "Se ha restaurado el curso correctamente"
                    );
                    this.listCourses();
                    this.optionSelected = "";
                }
            } catch (error) {
                alert(error);
            }
        },
    },
};
</script>
<style>
.el-icon {
    width: 20px;
}
.el-select .el-input .el-select__caret::before {
    display: none !important;
}
.el-icon .el-select__caret .el-select__icon {
    transform: rotateZ(0deg);
}
#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
